module.exports = __webpack_public_path__ + "static/graphic-latest-9696dca07f2ed718ba94a5aa44c63326.svg";